import { PropsWithChildren } from 'react';

export const Paragraph = ({ children }: PropsWithChildren) => {
  if (!children) {
    return null;
  }

  return (
    <div className="mb-4 whitespace-pre-wrap" data-testid="p-markup">
      {children}
    </div>
  );
};
